import lmsAPI from "./lmsAPI";

class ThemesService {
  async index() {
    const res = await lmsAPI.get(`/themes`);
    return res.data;
  }

  async get(id) {
    const res = await lmsAPI.get(`/themes/${id}`);
    return res.data;
  }

  async getTemplates(id) {
    const res = await lmsAPI.get(`/themes/${id}/templates`);
    return res.data;
  }

  async getLanguage(id) {
    const res = await lmsAPI.get(`/themes/${id}/language_schema`);
    return res.data;
  }

  async getSettings(id) {
    const res = await lmsAPI.get(`/themes/${id}/settings_schema`);
    return res.data;
  }

  async update(id, themeParams) {
    const res = await lmsAPI.put(`/themes/${id}`, { theme: themeParams });
    return res.data;
  }

  async updateTemplates(id, newTemplates) {
    const res = await lmsAPI.put(
      `/themes/${id}/update_templates`,
      newTemplates
    );
    return res.data;
  }

  async updateLanguage(id, newSchema) {
    const res = await lmsAPI.put(`/themes/${id}/language_schema`, {
      language_schema: { content: JSON.stringify(newSchema, null, "\t") },
    });
    return res.data;
  }

  async updateSettings(id, newSchema) {
    const res = await lmsAPI.put(`/themes/${id}/settings_schema`, {
      settings_schema: { content: JSON.stringify(newSchema, null, "\t") },
    });
    return res.data;
  }
}

export default new ThemesService();
